import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="transparent"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.5019 22.0042C14.0158 22.0042 12 19.9883 12 17.5023C12 15.0163 14.0158 13.0004 16.5019 13.0004C18.9889 13.0004 21.0037 15.0163 21.0037 17.5023C21.0037 19.9883 18.9889 22.0042 16.5019 22.0042"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5009 19.8883C16.4769 19.8883 16.4558 19.9093 16.4558 19.9333C16.4558 19.9573 16.4769 19.9783 16.5009 19.9783C16.5249 19.9783 16.5459 19.9573 16.5459 19.9333C16.5459 19.9093 16.5259 19.8883 16.5009 19.8883V19.8883"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5009 18.0655C17.2782 18.0655 17.9085 17.4353 17.9085 16.6579C17.9085 15.8806 17.2792 15.2504 16.5009 15.2504C15.7425 15.2504 15.1293 15.8496 15.1003 16.6009"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.0025 9.99917V7.82626C18.0025 7.29604 17.7914 6.78683 17.4162 6.41167L14.5871 3.58249C14.2119 3.20734 13.7027 2.99625 13.1725 2.99625H5.99749C4.89203 2.99625 3.99666 3.89162 3.99666 4.99708V19.0029C3.99666 20.1084 4.89203 21.0037 5.99749 21.0037H9.99916"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.0025 7.99833H14.0008C13.4486 7.99833 13.0004 7.55015 13.0004 6.99792V2.99625"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgComponent
